__turbopack_context__.v({
  "loading": "skeleton-module__TRew5a__loading",
  "skeleton": "skeleton-module__TRew5a__skeleton",
});
